import React, { memo } from 'react';
import PropTypes from 'prop-types';
import SocialMediaIcons from './SocialMediaIcons';

const ProfileSection = memo(({ profile, socialMediaIcons, isMobile }) => {
  const containerClass = isMobile
    ? "flex flex-col w-full max-w-[360px] h-[120px] items-center justify-center"
    : "sm:flex-col w-full max-w-[550px] h-[400px] hidden sm:flex items-center justify-center animate-slide-in-left";

  const imageClass = isMobile
    ? "w-[100px] h-[100px] rounded-full ring-2 ring-primary-300 transition-transform hover:scale-105"
    : "w-[150px] h-[150px] rounded-full ring-4 ring-primary-300 shadow-lg transition-transform hover:scale-105";

  const nameClass = isMobile 
    ? "font-bold mt-2 text-[14px] text-primary-900" 
    : "font-bold mt-2 text-primary-900 text-2xl";
  
  const roleClass = isMobile 
    ? "text-[13px] text-secondary-700" 
    : "text-secondary-700 text-lg";

  return (
    <div className={containerClass}>
      <img 
        src={profile.img} 
        className={`${imageClass} transition-all duration-300`} 
        alt="Profile Picture" 
      />
      <h2 className={`${nameClass} animate-fade-in`}>{profile.name}</h2>
      <h3 className={`${roleClass} animate-fade-in delay-100`}>{profile.role}</h3>
      <div className={`flex items-center justify-center ${isMobile ? "h-[20px] w-[140px]" : "h-[40px] w-[200px]"} mt-2 animate-fade-in delay-200`}>
        <SocialMediaIcons icons={socialMediaIcons} isMini={isMobile} />
      </div>
    </div>
  );
});

ProfileSection.propTypes = {
  profile: PropTypes.shape({
    img: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    role: PropTypes.string.isRequired,
    intro: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  }).isRequired,
  socialMediaIcons: PropTypes.array.isRequired,
  isMobile: PropTypes.bool,
};

export default ProfileSection; 